import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { router } from './app/router'
import { RoleProvider } from './app/role'
import { AuthProvider } from './lib/auth/auth'
import { initMsal } from './lib/auth/msal'
import { initTheme } from './app/theme'
import { initDensity } from './app/density'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/dm-sans'
import './styles/globals.css'

initTheme()
initDensity()

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
})

// Initialise MSAL (no-op when no Entra app is configured) before first render.
initMsal().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RoleProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </RoleProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  )
})
